import React from 'react';
// import { InfoSection } from '../../components';
import About from '../../components/InfoSection/About';
// import { homeObjOne,homeObjTwo, homeObjThree } from './Data';

function aboutus() {
  return (
    <>
      <About />
    </>
  );
}

export default aboutus;
